import { FormField, InputSelectField } from '@tempmee/react';
import { forwardRef, memo, type Ref } from 'react';

interface IMealBreakDurationFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  hasError?: boolean;
}

const BREAK_DURATION_OPTIONS = ['0 min', '15 min', '30 min', '45 min', '1 hr', '1.5 hr', '2 hr'].map(
  (v) => ({ label: v, value: v }),
);

const Component = (
  { value, onChange, hasError }: IMealBreakDurationFieldProps,
  ref: Ref<HTMLDivElement>,
) => (
  <div ref={ref} data-testid="meal-break-duration-field" data-cy="meal-break-duration-field">
    <FormField label="Meal Break Duration">
      <InputSelectField<string>
        options={BREAK_DURATION_OPTIONS}
        value={value}
        onChange={onChange}
        placeholder="Select Duration"
        isError={Boolean(hasError)}
      />
    </FormField>
  </div>
);

export const MealBreakDurationField = memo(forwardRef(Component));
